import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import ProductionCaseCardWidget from './ProductionCaseCardWidget'


const mapStateToProps = (state, props) => {
    return {
        salesOrder: selector.selectSalesOrder(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ProductionCaseCardWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/ProductionCaseCardWidgetContainer.js